import React from 'react';
import { useInternationalization } from '../../features/i18n';
import { TestimoniTableRow } from './testimoni-table-row';

const TestimonialTable = ({data, withAction = true, onEdit, onDelete}) => {
  const { translate } = useInternationalization()

  return (
    <div>
      {
        data &&
        data.map((d, index) => (
          <div
            className={`flex justify-between p-5`}
            style={{background: index % 2 === 0 ? '#f9f9f9' : '#ffffff'}}
            key={d.id}
          >
            <TestimoniTableRow
              image={d.image}
              title={d.name}
              content={d.text}
            />
            {
              withAction &&
              <div className="pl-4 lg:pl-10 flex">
                {
                  onEdit &&
                  <p className="cursor-pointer underline text-xs text-primary mr-2" onClick={() => onEdit(d)}>Edit</p>
                }
                {
                  onDelete &&
                  <p className="cursor-pointer underline text-xs text-gray-999" onClick={() => onDelete(d)}>
                    {translate('GENERAL', 'delete')}
                  </p>
                }
              </div>
            }
          </div>
        ))
      }
    </div>
  )
}

export default TestimonialTable

// BACKUP
// const defaultData = [
//   {
//     id: 1,
//     name: 'Zulfikar Akbar',
//     text: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
//     image: '/images/khub_anwar.jpg'
//   },
//   {
//     id: 2,
//     name: 'Huda Albana',
//     text: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
//     image: '/images/khub_anwar.jpg'
//   },
//   {
//     id: 3,
//     name: 'Dannie Zufro',
//     text: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
//   }
// ]
